/* eslint-disable */
import intl from 'react-intl-universal'
import locales from './locales'
import initAngularLocale from './locale-data'

let currentLocale = intl.determineLocale()
// react-intl-universal has fallbackLocale logic broken DO NOT REMOVE!
if (locales && !locales.hasOwnProperty(currentLocale)) {
  currentLocale = currentLocale.substring(0, 2).toLowerCase()
  currentLocale = locales.hasOwnProperty(currentLocale) ? currentLocale : 'en'
}

// Since react-intl-universal loading data through script tag, have
// to supply something JS parsable, in this case, an empty object
const EMPTY_SRC = 'data:application/javascript;charset=utf-8;base64,e30='
const init = {
  currentLocale,
  fallbackLocale: 'en',
  locales,
  // Keep commonLocaleDataUrls empty to prevent CDN load of locale data
  // In case of adding new languages, ./locale-data folder should be updated
  commonLocaleDataUrls: {
    ar: EMPTY_SRC,
    en: EMPTY_SRC,
    "en-NZ": EMPTY_SRC,
    zh: EMPTY_SRC,
    fr: EMPTY_SRC,
    fa: EMPTY_SRC,
    ja: EMPTY_SRC,
    de: EMPTY_SRC,
    es: EMPTY_SRC,
    ko: EMPTY_SRC,
    pt: EMPTY_SRC,
    it: EMPTY_SRC,
    ru: EMPTY_SRC,
    pl: EMPTY_SRC,
    nl: EMPTY_SRC,
    nb: EMPTY_SRC,
    nn: EMPTY_SRC,
    no: EMPTY_SRC,
    sv: EMPTY_SRC,
    tr: EMPTY_SRC,
  },
  escapeHtml: false,
}

if (process.env.NODE_ENV === 'production') {
  init.warningHandler = () => {
    // empty function
  }
}

intl.init(init)

initAngularLocale(currentLocale)
